<template>
  <layout>
    <v-tooltip bottom nudge-bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          x-large
          v-bind="attrs"
          v-on="on"
          icon @click="returnHandler()"
          class="arrow-back-icon pt-10"
        >
          keyboard_arrow_left
        </v-icon>
      </template>
      <span>{{ i18n('Voltar para o login') }}</span>
    </v-tooltip>
    <div class="mx-auto dark-color" style="width: 370px; margin-top: -5%;" >
      <div class=" mx-auto mt-20 flex justify-center" style="width: 370px">
        <img :src="logoPath()" />
      </div>
      <v-form class="mt-20" v-model="form_valid" ref="form">
        <h2 class="max">{{ i18n('Redefinição de senha') }}</h2>
        <h4 class="mt-3 mb-3">{{ i18n(feedback_text)}}</h4>
        <v-flex>
          <v-text-field
            outline
            color="secondary-button-background-color"
            v-model="email"
            background-color="input-color"
            label="E-mail"
            :rules="[email_rule]"
            @keyup.enter="resetPassword()"
            v-if="!task_complete"
          ></v-text-field>
        </v-flex>
        <v-btn v-if="!task_complete" class="sign-btn" block large @click="resetPassword()">
          <div style="display:inline-flex; flex:1; justify-content: center;">
            <h3 class="font-bold text-lg">{{ i18n('Solicitar') }}</h3>
          </div>
        </v-btn>
      </v-form>
    </div>
  </layout>
</template>

<script>
import LoginLayout from "./layouts/LoginLayout"
import Title from "./components/Title"

export default {
  name: 'ResetPassword',
  components: { layout: LoginLayout, 'page-title': Title },
  data: () => {
    return {
      email: '',
      form_valid: false,
      task_complete: false,
      feedback_text: 'Informe seu E-mail'
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    logoPath() {
      if (this.$root.getEnvironment() === 'prod') return 'static/logo.svg'
      return 'static/logo-dev.svg'
    },
    email_rule(val) {
      return (
        (/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i).test(val)
        || this.i18n('Digite um e-mail válido')
      )
    },
    returnHandler() { this.$router.push(this.signedIn ? '/dashboard' : '/') },
    resetPassword() {
      this.$refs.form.validate()
      if (!this.form_valid) return

      const payload = {
        email: this.email
      }

      let successCallback = (response) => {
        if (response.body.data == 'ok') {
          this.feedback_text = 'Um link para criar nova senha foi enviado para o e-mail inserido, caso ele exista em nosso sistema. Siga as instruções contidas nele para redefinir sua senha.'
        } else {
          this.feedback_text = 'Ocorreu um erro inesperado. Entre em contato com o nosso suporte.'
          console.log('successCallback', response)
        }
        this.task_complete = true;
      }

      let errorCallback = (response) => {
        this.feedback_text = 'Ocorreu um erro inesperado. Entre em contato com o nosso suporte.'
        console.log(response)
        this.task_complete = true;
      }

      this.$http.post(this.$root.urls.request_password_reset, payload).then(successCallback, errorCallback)
    }
  },
  mounted() {
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style scoped>
.pt-10{
  padding: 2.5rem;
}

.mt-20{
  margin-top: 5rem;
}

.flex{
  display: flex;
}

/* Vue defaults to white, so we'll be using this class to force the dark color */
.dark-color {
  color: var(--primary-dark-font-color) !important;
}

.justify-center{
  justify-content: center;
}

.sign-btn{
  padding: 30px;
  background-color: #27DABC  !important;
}
.sign-btn:hover {
  opacity: 0.80;
}

.arrow-back-icon{
  width: 50px;
  margin-left: 30px;
  display: flex;
  align-items: end;
  justify-content: flex-start;
  color: var(--primary-dark-font-color) !important;
}

.arrow-back-icon:hover{
  cursor: pointer;
  color: #27DABC !important;
}

.v-text-field .v-input__slot {
  border: 1.5px solid #282C2B !important;
  color: var(--primary-dark-font-color) !important;
  border-radius: 4px;
}

.dark-color >>> .v-label,
.dark-color >>> .v-label.v-label--active {
  color: var(--primary-dark-font-color) !important;
}

.dark-color >>> .v-input__slot input {
  color: var(--primary-dark-font-color) !important;
}
.dark-color >>> .v-text-field .v-input__slot {
  border: 1.5px solid #282C2B !important;
  border-radius: 4px;
}

.dark-color >>> .v-input.error--text .v-input__slot,
.dark-color >>> .v-text-field.error--text .v-input__slot {
  border-color: #FF5252 !important;
}

.mx-auto {
  margin-left: auto !important;
  margin-right: auto !important;
}

.mt-5{
  margin: 1.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/ResetPassword.vue